<div id="lista" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg fundo_cinza"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div
            class="header"
            fxLayout="column"
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="space-between center"
            [ngClass]="{ fundo_acent: data == 1, fundo_amarelo: data == 2, fundo_azul: data == 3 }"
        >
            <!-- TITLE AND ACTION BUTTONS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
                <!-- APP TITLE -->
                <div class="logo mb-24 mb-md-0" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="logo-icon s-32 mr-16" style="color: #fff"> business </mat-icon>
                    <span class="logo-text h1" style="color: #fff"> Boleta Única </span>
                </div>
                <!-- / APP TITLE -->

                <!-- ACTION BUTTONS -->
                <div fxLayout="row" fxLayoutAlign="start center" style="margin-left: 16px; gap: 8px">
                    <!-- Consult Button -->
                    <button mat-mini-fab color="accent" matTooltip="Consultar Boleta" (click)="openFiltro()">
                        <mat-icon>search</mat-icon>
                    </button>

                    <!-- Export Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Exportar Boleta"
                        (click)="getAllExport()"
                        *ngIf="user.role_id == 2 || user.role_id == 7 || user.role_id == 4"
                    >
                        <mat-icon>cloud_download</mat-icon>
                    </button>

                    <!-- Add Button -->
                    <button mat-mini-fab color="accent" matTooltip="Adicionar Boleta" (click)="openCadastro()">
                        <mat-icon>add_circle</mat-icon>
                    </button>

                    <!-- Update Status Button -->
                    <button
                        mat-mini-fab
                        color="accent"
                        matTooltip="Atualizar Status"
                        (click)="openAtualizar()"
                        *ngIf="user.role_id == 2 || user.role_id == 7 || user.role_id == 4"
                    >
                        <mat-icon>update</mat-icon>
                    </button>
                </div>
                <!-- / ACTION BUTTONS -->
            </div>
            <!-- / TITLE AND ACTION BUTTONS -->
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- Loading Indicator -->
            <div *ngIf="loadingIndicator" class="loading-container p-16" style="text-align: center">
                <mat-spinner diameter="30"></mat-spinner>
                <span style="margin-left: 8px" data-testid="loading-indicator">Carregando...</span>
            </div>

            <ngx-datatable
                #table
                class="material striped"
                [columns]="columns"
                [columnMode]="'force'"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="'auto'"
                [selected]="selected"
                [selectionType]="SelectionType.checkbox"
                [selectAllRowsOnPage]="false"
                (select)="onSelect($event)"
                (sort)="onSort($event)"
                [rows]="rows"
            >
                <ngx-datatable-column
                    [width]="30"
                    [sortable]="false"
                    [canAutoResize]="false"
                    [draggable]="false"
                    [resizeable]="false"
                    [headerCheckboxable]="true"
                    [checkboxable]="true"
                    *ngIf="this.user.role_id == 2 || this.user.role_id == 4 || this.user.role_id == 7"
                >
                </ngx-datatable-column>

                <ngx-datatable-column name="Data" prop="data_operacao" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-data_operacao="value" ngx-datatable-cell-template>
                        {{ data_operacao | date : "dd/MM/yyyy H:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    title="Data de Atualização"
                    name="Dt Atualização"
                    prop="updated_at"
                    [sortable]="true"
                >
                    <ng-template let-rowIndex="rowIndex" let-updated_at="value" ngx-datatable-cell-template>
                        {{ updated_at | date : "dd/MM/yyyy H:mm" }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    name="Responsável"
                    matTooltip="Responsavel por realizar a operação"
                    prop="operador_id"
                    [sortable]="true"
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.operador.name }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column
                    name="Escritório"
                    prop="escritorio_id"
                    [sortable]="false"
                    *ngIf="this.user.role_id != 5"
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{ row.cliente.escritorio.nome_fantasia }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template>
                        {{ cliente.numero_xp }} - {{ cliente.nome }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Tipo" prop="tipo_boleta" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-tipo_boleta="value" ngx-datatable-cell-template>
                        {{ tipo_boleta }}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Status" prop="status" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span
                            [ngClass]="{
                                status_boleta_efetivada: row.status_id == 10,
                                status_efeitivada_parcial: row.status_id == 15,
                                status_boleta_error:
                                    row.status_id != 10 &&
                                    row.status_id != 1 &&
                                    row.status_id != 2 &&
                                    row.status_id != 3
                            }"
                        >
                            {{ row.status.nome }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Ação" prop="id" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <button mat-icon-button matTooltip="Visualizar Boleta Única" (click)="openVisualizar(row.id)">
                            <mat-icon aria-label="Visualizar" style="font-size: 18px">search</mat-icon>
                        </button>

                        <span
                            *ngIf="
                                (this.user.role_id != 2 &&
                                    this.user.role_id != 4 &&
                                    this.user.role_id != 7 &&
                                    row.status_id != 10 &&
                                    row.status_id != 3) ||
                                this.user.role_id == 2 || this.user.role_id == 4 || this.user.role_id == 7
                            "
                        >
                            <button
                                mat-icon-button
                                matTooltip="Altera Boleta"
                                (click)="openAlterar(row.id)"
                                *ngIf="row.status_id != 10 || row.status_id == 16"
                            >
                                <mat-icon aria-label="Editar" style="font-size: 18px">edit</mat-icon>
                            </button>

                            <button mat-icon-button color="warn" matTooltip="Excluir Boleta." (click)="delete(row.id)">
                                <mat-icon aria-label="Excluir Boleta" style="font-size: 18px">delete</mat-icon>
                            </button>
                        </span>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator
                    #paginator
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)"
                >
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
